(function () {
  var IG_CLASS = 'ig-review-first';
  var ACTIVE_CLASS = 'rf-pdp-active';

  function isActive(alwaysOn) {
    return alwaysOn || document.body.classList.contains(IG_CLASS);
  }

  function setBodyActiveClass(alwaysOn) {
    if (!document.body) return;
    var shouldBeActive = isActive(alwaysOn);
    var hasClass = document.body.classList.contains(ACTIVE_CLASS);
    if (shouldBeActive && !hasClass) {
      document.body.classList.add(ACTIVE_CLASS);
    } else if (!shouldBeActive && hasClass) {
      document.body.classList.remove(ACTIVE_CLASS);
    }
  }

  function money(cents, currency) {
    if (currency === 'USD') return 'US$' + (cents / 100).toFixed(2);
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
  }

  function initHead(cfg) {
    var sectionId = cfg.sectionId;
    var headKey = 'rfHeadBooted' + sectionId;
    if (document.documentElement.dataset[headKey]) return;
    document.documentElement.dataset[headKey] = '1';

    var alwaysOn = cfg.alwaysOn;
    var stockLeft = cfg.stockLeft;
    var headReady = false;

    function moveBadgeBelowTitle(root) {
      var title = root.querySelector('.product__title');
      var badge = root.querySelector('.jdgm-preview-badge, .jdgm-prev-badge');
      if (!title || !badge) return;
      var wrap =
        badge.closest('shopify-block') ||
        badge.closest('[id^="shopify-block-"]') ||
        badge.closest('.shopify-app-block') ||
        badge.parentElement;
      if (!wrap || !title.parentNode) return;
      // Keep customizer order: title → benefit list (if present) → stars
      var benefit = root.querySelector('.pdp-benefit-list');
      var anchor = benefit && benefit.parentNode === title.parentNode ? benefit : title;
      if (anchor.nextElementSibling === wrap) return;
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    }

    function formatLowStock(root) {
      var inv = root.querySelector('.product__inventory');
      if (!inv || inv.dataset.rfFormatted) return;
      inv.dataset.rfFormatted = '1';
      inv.innerHTML = 'Low in stock — ' + stockLeft + ' left';
    }

    function init() {
      setBodyActiveClass(alwaysOn);
      if (alwaysOn) document.documentElement.classList.remove('rf-pdp-pending');
      if (!isActive(alwaysOn)) return;
      var root = document.getElementById('ProductInfo-' + sectionId);
      if (!root) return;
      moveBadgeBelowTitle(root);
      formatLowStock(root);
      headReady = true;
    }

    function watchIgClass() {
      if (alwaysOn || !document.body) return;
      var obs = new MutationObserver(function () {
        setBodyActiveClass(alwaysOn);
        if (!headReady && isActive(alwaysOn)) init();
      });
      obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    if (alwaysOn) {
      document.documentElement.classList.add('rf-pdp-pending');
      function markActive() {
        if (!document.body) return;
        document.body.classList.add(ACTIVE_CLASS);
      }
      if (document.body) markActive();
      else document.addEventListener('DOMContentLoaded', markActive, { once: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
        watchIgClass();
      });
    } else {
      init();
      watchIgClass();
    }

    document.addEventListener('shopify:section:load', init);
  }

  function initBuybox(root) {
    var cfg = root.dataset;
    var sectionId = cfg.sectionId;
    var alwaysOn = cfg.alwaysOn === 'true';
    var kachingBundleActive = cfg.kachingBundleActive === 'true';
    var currency = cfg.currency;
    var otPrice = parseInt(cfg.otPrice, 10);
    var subPrice = parseInt(cfg.subPrice, 10);
    var comparePrice = parseInt(cfg.comparePrice, 10);
    var sellingPlanId = cfg.sellingPlanId;
    var supplySub = cfg.supplySub;
    var supplyOnce = cfg.supplyOnce;

    var tabs = root.querySelectorAll('[data-rf-plan]');
    var switchBtn = root.querySelector('[data-rf-goto]');
    var saveEl = root.querySelector('[data-rf-save]');
    var supplyEl = root.querySelector('[data-rf-supply]');
    var nowEl = root.querySelector('[data-rf-now]');
    var wasEl = root.querySelector('[data-rf-was]');
    var divline = root.querySelector('[data-rf-divline]');
    var bens = root.querySelector('[data-rf-bens]');
    var planCard = root.querySelector('[data-rf-plan-card]');
    var planIn = document.getElementById('rf-selling-plan-' + sectionId);
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    var form = root.querySelector('.rf-form');
    var formError = root.querySelector('.product-form__error-message');
    var formErrorWrapper = root.querySelector('.product-form__error-message-wrapper');
    var atcButton = document.getElementById('rf-atc-' + sectionId);
    var buyboxReady = false;
    var currentPlan = 'sub';
    var isAdding = false;

    function getKachingPlanCards() {
      if (!productInfo) return [];
      var subscriptionPicker = productInfo.querySelector('.kaching-bundles__subscriptions');
      if (!subscriptionPicker) return [];
      return Array.prototype.filter.call(subscriptionPicker.children, function (child) {
        return child.classList && child.classList.contains('kaching-bundles__bar');
      });
    }

    function syncKachingPlan(plan) {
      var cards = getKachingPlanCards();
      if (!cards.length) return false;

      // Kaching renders Subscribe first and One-time second. Its selling-plan
      // select is removed from the DOM while One-time is active, so it cannot
      // be used to identify the subscription card after the first switch.
      var target = plan === 'sub' ? cards[0] : cards[1];
      if (!target) return false;

      if (!target.classList.contains('kaching-bundles__bar--selected')) {
        var targetCard = target.querySelector('.kaching-bundles__subscriptions__card');
        if (!targetCard) return false;
        targetCard.click();
      }

      if (plan === 'sub') {
        var sellingPlanSelect = target.querySelector('.kaching-bundles__selling-plan-select');
        if (sellingPlanSelect && sellingPlanId) {
          var hasConfiguredPlan = Array.prototype.some.call(sellingPlanSelect.options, function (option) {
            return option.value === sellingPlanId;
          });
          if (hasConfiguredPlan && sellingPlanSelect.value !== sellingPlanId) {
            sellingPlanSelect.value = sellingPlanId;
            sellingPlanSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      return true;
    }

    function isKachingPlanSelected(plan) {
      var cards = getKachingPlanCards();
      var selectedIndex = plan === 'sub' ? 0 : 1;
      return Boolean(cards[selectedIndex] && cards[selectedIndex].classList.contains('kaching-bundles__bar--selected'));
    }

    function showFormError(message) {
      if (formError) formError.textContent = message;
      if (formErrorWrapper) formErrorWrapper.hidden = !message;
    }

    function hasReadyKachingItems(widget, plan) {
      if (!widget || typeof widget.items !== 'function') return false;
      var items = widget.items();
      if (!items.length) return false;
      var deal = JSON.parse(widget.getAttribute('deal-block'));
      var selected = deal.dealBars.find(function (bar) { return bar.id === widget.selectedDealBarId; });
      if (!selected) return false;
      var gifts = (selected.freeGifts || []).filter(function (gift) {
        return !gift.applyOnlyForSubscriptions || plan === 'sub';
      });
      return gifts.every(function (gift) {
        return items.some(function (item) {
          var bundle = JSON.parse(item.properties.__kaching_bundles);
          return bundle.gift === gift.id && item.quantity >= gift.quantity;
        });
      });
    }

    function waitForKaching(plan) {
      return new Promise(function (resolve, reject) {
        var startedAt = Date.now();

        function check() {
          syncKachingPlan(plan);
          var bundleInput = form && form.querySelector('input[name="properties[__kaching_bundles]"]');
          var widget = productInfo && productInfo.querySelector('kaching-bundles-block');
          try {
            if (bundleInput && isKachingPlanSelected(plan) && hasReadyKachingItems(widget, plan)) {
              resolve();
              return;
            }
            if (Date.now() - startedAt >= 5000) {
              reject(new Error('Kaching bundle did not become ready.'));
              return;
            }
            window.setTimeout(check, 50);
          } catch (error) {
            reject(error);
          }
        }

        check();
      });
    }

    function setAdding(adding) {
      isAdding = adding;
      window.strawberryBundlePending = adding;
      document.dispatchEvent(new CustomEvent('strawberry:bundle-pending'));
      tabs.forEach(function (tab) { tab.disabled = adding; });
      if (switchBtn) switchBtn.disabled = adding;
      root.querySelectorAll('[data-rf-otp-link] a, [data-rf-otp-back] a').forEach(function (link) {
        link.style.pointerEvents = adding ? 'none' : '';
        link.setAttribute('aria-disabled', adding ? 'true' : 'false');
      });
      if (!atcButton) return;
      atcButton.disabled = adding;
      atcButton.toggleAttribute('aria-busy', adding);
      var spinner = atcButton.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.toggle('hidden', !adding);
    }

    function addKachingBundle(event, forcePlan) {
      // Own this form's click before Kaching's button listener adds extras
      // sequentially. Kaching still supplies every item and discount property.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form || !atcButton || isAdding || window.strawberryBundlePending) return;
      var plan = forcePlan || currentPlan;
      setAdding(true);
      showFormError('');

      waitForKaching(plan)
        .then(async function () {
          var widget = productInfo.querySelector('kaching-bundles-block');
          if (!widget || typeof widget.items !== 'function' || typeof widget.rotateBundleNonce !== 'function' ||
              typeof widget.validateItemSelection !== 'function') {
            throw new Error('Kaching bundle is not ready. Please reload the page.');
          }
          if (!widget.validateItemSelection().valid) {
            throw new Error('Please complete your bundle selection.');
          }

          widget.rotateBundleNonce();
          await waitForKaching(plan);
          var items = widget.items();
          var formData = new FormData(form);
          var expectedVariantId = String(formData.get('id'));
          var mainIndex = items.findIndex(function (item) {
            var bundle = JSON.parse(item.properties.__kaching_bundles);
            return String(item.id) === expectedVariantId && bundle.main === true;
          });
          if (mainIndex < 0) throw new Error('The main Kaching bundle product is missing.');

          var formProperties = {};
          formData.forEach(function (value, name) {
            var match = name.match(/^properties\[(.*)\]$/);
            if (match && match[1] !== '__kaching_bundles') formProperties[match[1]] = value;
          });
          var mainItem = Object.assign({}, items[mainIndex], {
            properties: Object.assign({}, formProperties, items[mainIndex].properties)
          });
          // Kaching can retain/re-enable its previous selling plan on the
          // one-time tab. Preserve the review-first tab's explicit choice.
          var selectedPlan = plan === 'sub' ? sellingPlanId : null;
          if (selectedPlan) mainItem.selling_plan = selectedPlan;
          else delete mainItem.selling_plan;
          // Match Kaching's separate-request path: extras cannot reference a
          // parent line that may not exist yet. Bundle properties link them.
          var extras = items.filter(function (_, index) { return index !== mainIndex; }).map(function (item) {
            var extra = Object.assign({}, item);
            delete extra.parent_id;
            return extra;
          });
          var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

          async function addItems(batch) {
            var response = await fetch(window.Shopify.routes.root + 'cart/add.js?kaching_bundles=true&partial=true', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: batch })
            });
            var data = await response.json();
            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || 'Could not add bundle to cart.');
            }
            var addedItems = Array.isArray(data.items) ? data.items : [data];
            batch.forEach(function (expected) {
              var added = addedItems.find(function (item) {
                return String(item.variant_id || item.id) === String(expected.id) &&
                  item.properties && item.properties.__kaching_bundles === expected.properties.__kaching_bundles;
              });
              if (!added || String(added.selling_plan_allocation && added.selling_plan_allocation.selling_plan.id || '') !==
                  String(expected.selling_plan || '')) {
                throw new Error('Kaching bundle details did not match the cart.');
              }
            });
            return data;
          }

          async function readCart() {
            var response = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
            if (!response.ok) throw new Error('Could not verify your cart. Please reload the page.');
            return response.json();
          }
          // Establish/read this session's cart before concurrent mutations.
          var beforeCart = await readCart();
          var expectedItems = [mainItem].concat(extras);
          function matchingQuantity(cartState, expected) {
            return cartState.items.reduce(function (quantity, item) {
              return String(item.variant_id || item.id) === String(expected.id) &&
                item.properties && item.properties.__kaching_bundles === expected.properties.__kaching_bundles
                ? quantity + item.quantity : quantity;
            }, 0);
          }
          var expectedQuantities = expectedItems.map(function (item) {
            return matchingQuantity(beforeCart, item) + Number(item.quantity);
          });
          // Start both writes before awaiting either, then verify the final
          // cart: a successful add response alone does not prove both survived.
          var requests = [addItems([mainItem])];
          if (extras.length) requests.push(addItems(extras));
          var results = await Promise.allSettled(requests);
          var failed = results.find(function (result) { return result.status === 'rejected'; });
          if (failed) {
            throw new Error(failed.reason.message + ' Your cart may be partially updated. Please review it before adding again.');
          }

          var finalCart = await readCart();
          var missing = expectedItems.map(function (item, index) {
            var quantity = expectedQuantities[index] - matchingQuantity(finalCart, item);
            return quantity > 0 ? Object.assign({}, item, { quantity: quantity }) : null;
          }).filter(Boolean);
          if (missing.length) {
            // Repair only quantities proven absent after successful responses.
            // Never replay an entire bundle or blindly retry a failed request.
            await addItems(missing);
            finalCart = await readCart();
          }
          if (expectedItems.some(function (item, index) {
            return matchingQuantity(finalCart, item) < expectedQuantities[index];
          })) throw new Error('Your bundle is incomplete. Please review your cart before checkout.');
          var giftProperties = extras.filter(function (item) {
            return JSON.parse(item.properties.__kaching_bundles).gift;
          }).map(function (item) { return item.properties.__kaching_bundles; });
          if (finalCart.items.some(function (item) {
            return item.properties && giftProperties.includes(item.properties.__kaching_bundles) && item.final_line_price !== 0;
          })) throw new Error('The free gift discount was not applied. Please review your cart before checkout.');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (window.kachingCartApi && typeof window.kachingCartApi.refreshCart === 'function') {
            await window.kachingCartApi.refreshCart();
          }

          // Either add response can contain an incomplete cart snapshot.
          // Render sections only after both writes have finished.
          if (cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function') {
            var sectionIds = cart.getSectionsToRender().map(function (section) { return section.id; });
            var response = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionIds.join(',')));
            if (!response.ok) throw new Error('Bundle added, but the cart could not refresh. Please reload the page.');
            var sections = await response.json();
            if (sectionIds.some(function (id) { return !sections[id]; })) {
              throw new Error('Bundle added, but the cart could not render. Please reload the page.');
            }
            cart.renderContents(Object.assign({}, results[0].value.items[0], { sections: sections }));
          }
        })
        .catch(function (error) {
          console.error('Review-first Kaching bundle add failed:', error);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          showFormError(error.message || 'Could not add bundle to cart.');
        })
        .finally(function () {
          setAdding(false);
          // OTP silent add can leave Kaching on one-time — restore visible plan.
          if (forcePlan && forcePlan !== currentPlan) {
            if (currentPlan === 'sub' && planIn) {
              planIn.disabled = false;
              planIn.value = sellingPlanId;
            }
            syncKachingPlan(currentPlan);
          }
        });
    }

    function addOneTimeSilent() {
      if (!form || isAdding || window.strawberryBundlePending) return;
      setAdding(true);
      showFormError('');
      var formData = new FormData(form);
      var variantId = Number(formData.get('id'));
      var quantity = Number(formData.get('quantity') || 1) || 1;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            throw new Error(res.data.description || res.data.message || 'Could not add to cart.');
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (typeof window.openStrawberryBag === 'function' && window.openStrawberryBag()) return;
          if (window.kachingCartApi && typeof window.kachingCartApi.refreshCart === 'function') {
            return Promise.resolve(window.kachingCartApi.refreshCart()).then(function () {
              if (window.kachingCartApi.openCart) window.kachingCartApi.openCart();
            });
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(Array.isArray(res.data.items) ? res.data.items[0] : res.data);
          }
        })
        .catch(function (error) {
          console.error('Review-first one-time add failed:', error);
          showFormError(error.message || 'Could not add to cart.');
        })
        .finally(function () {
          setAdding(false);
        });
    }

    function giftBlocks() {
      var blocks = [];
      if (!planCard) return blocks;
      function add(el) {
        if (!el || blocks.indexOf(el) !== -1) return;
        blocks.push(el);
      }
      planCard.querySelectorAll('ig-component, .rf-gift').forEach(add);
      var labels = planCard.querySelectorAll('span, div, strong, b');
      for (var i = 0; i < labels.length; i++) {
        if ((labels[i].textContent || '').replace(/\s+/g, ' ').trim() !== 'YOUR FREE GIFT') continue;
        add(labels[i].closest('ig-component') || (labels[i].parentElement && labels[i].parentElement.parentElement));
      }
      return blocks;
    }

    function setGiftVisibility(visible) {
      giftBlocks().forEach(function (el) {
        el.hidden = !visible;
        if (visible) el.style.removeProperty('display');
        else el.style.setProperty('display', 'none', 'important');
      });
    }

    function showRoot() {
      root.hidden = !isActive(alwaysOn);
    }

    function setPlan(plan) {
      currentPlan = plan;
      tabs.forEach(function (t) {
        t.classList.toggle('rf-tab-on', t.dataset.rfPlan === plan);
      });
      if (planCard) planCard.classList.toggle('rf-plan--compact', plan === 'once');

      if (plan === 'sub') {
        if (saveEl) saveEl.hidden = false;
        if (supplyEl) supplyEl.textContent = supplySub;
        if (nowEl) nowEl.textContent = money(subPrice, currency);
        if (wasEl) {
          wasEl.textContent = money(comparePrice, currency);
          wasEl.hidden = false;
        }
        if (switchBtn) switchBtn.hidden = true;
        if (divline) divline.hidden = false;
        if (bens) bens.hidden = false;
        setGiftVisibility(true);
        if (planIn) {
          planIn.disabled = false;
          planIn.value = sellingPlanId;
        }
      } else {
        if (saveEl) saveEl.hidden = true;
        if (supplyEl) supplyEl.textContent = supplyOnce;
        if (nowEl) nowEl.textContent = money(otPrice, currency);
        if (wasEl) wasEl.hidden = true;
        if (switchBtn) switchBtn.hidden = false;
        if (divline) divline.hidden = true;
        if (bens) bens.hidden = true;
        setGiftVisibility(false);
        if (planIn) planIn.disabled = true;
      }

      syncQuietOtp();
      syncKachingPlan(plan);
      syncStickyPrice();
    }

    function syncStickyPrice() {
      var priceEl = document.querySelector('#atc-price-' + sectionId + ' .price-item--regular');
      if (!priceEl) return;
      var label = currentPlan === 'once' ? root.dataset.moneyOt : root.dataset.moneySub;
      if (label) priceEl.textContent = label;
    }

    function isQuietOtp() {
      if (root.dataset.quietOtp !== 'true') return false;
      var cls = root.dataset.quietOtpClass;
      return Boolean(cls && document.body && document.body.classList.contains(cls));
    }

    function syncQuietOtp() {
      var on = isQuietOtp();
      var once = currentPlan === 'once';
      root.classList.toggle('rf-otp-once', on && once);
      if (!once || !supplyEl) return;
      var quietSupply = root.dataset.otpSupply;
      supplyEl.textContent = (on && quietSupply) ? quietSupply : supplyOnce;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setPlan(tab.dataset.rfPlan);
      });
    });
    if (switchBtn) {
      switchBtn.addEventListener('click', function () {
        setPlan('sub');
      });
    }

    var otpLink = root.querySelector('[data-rf-otp-link] a');
    var otpBack = root.querySelector('[data-rf-otp-back] a');
    if (otpLink) {
      otpLink.addEventListener('click', function (event) {
        event.preventDefault();
        if (isAdding || window.strawberryBundlePending) return;
        // Quiet OTP: plain one-time add — skip Kaching wait/UI (no sub gift).
        addOneTimeSilent();
      });
    }
    if (otpBack) {
      otpBack.addEventListener('click', function (event) {
        event.preventDefault();
        setPlan('sub');
      });
    }
    if (root.dataset.quietOtp === 'true' && document.body) {
      new MutationObserver(function () {
        syncQuietOtp();
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    if (form && kachingBundleActive) form.addEventListener('click', function (event) {
      if (atcButton && atcButton.contains(event.target)) addKachingBundle(event);
    }, true);

    function initViewerCount() {
      var el = root.querySelector('.rf-viewer-count');
      if (!el || el.dataset.rfViewerInit) return;
      el.dataset.rfViewerInit = '1';
      var n = Math.floor(Math.random() * 901) + 1500;
      el.textContent = n.toLocaleString();
      setInterval(function () {
        n += Math.floor(Math.random() * 41) - 20;
        if (n < 1500) n = 1500;
        if (n > 2400) n = 2400;
        el.textContent = n.toLocaleString();
      }, 5000);
    }

    function initStickyAtc() {
      if (root.dataset.rfStickyInit) return;
      var stickyBtn = document.querySelector('#sticky-atc-' + sectionId + ' .sticky-atc__subscribe-btn');
      var atcBtn = document.getElementById('rf-atc-' + sectionId);
      if (!stickyBtn || !atcBtn) return;
      root.dataset.rfStickyInit = '1';
      var newBtn = stickyBtn.cloneNode(true);
      stickyBtn.parentNode.replaceChild(newBtn, stickyBtn);
      newBtn.dataset.rfStickyOwned = '1';
      newBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        atcBtn.click();
      });
    }

    function init() {
      showRoot();
      if (!isActive(alwaysOn)) return;
      if (!buyboxReady) {
        buyboxReady = true;
        if (planCard) {
          new MutationObserver(function () {
            setGiftVisibility(currentPlan === 'sub');
          }).observe(planCard, { childList: true, subtree: true });
        }
        setPlan('sub');
        initViewerCount();
        initStickyAtc();

        if (productInfo) {
          new MutationObserver(function () {
            syncKachingPlan(currentPlan);
          }).observe(productInfo, { childList: true, subtree: true });
        }
      }
    }

    if (!alwaysOn && document.body) {
      var obs = new MutationObserver(function () {
        showRoot();
        if (!buyboxReady && isActive(alwaysOn)) init();
      });
      obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  }

  function boot() {
    document.querySelectorAll('.rf-pdp[data-rf-init]').forEach(function (root) {
      if (root.dataset.rfBooted) return;
      root.dataset.rfBooted = '1';

      initHead({
        sectionId: root.dataset.sectionId,
        alwaysOn: root.dataset.alwaysOn === 'true',
        stockLeft: root.dataset.stockLeft
      });

      initBuybox(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

